import { extractEvent } from './extract-event';
export default extractEvent;
